import React, { useState } from 'react';
import { Search, Briefcase, FileText, Layout, Users, TrendingUp, Award } from 'lucide-react';
export function Services() {
  const [searchTerm, setSearchTerm] = useState('');
  const services = [{
    title: 'Board Resume Writing',
    category: 'Board',
    icon: <Layout className="w-6 h-6" data-id="element-374" />
  }, {
    title: 'Chairman Resume Writing',
    category: 'Board',
    icon: <Award className="w-6 h-6" data-id="element-375" />
  }, {
    title: 'Independent Director Resume Writing',
    category: 'Board',
    icon: <Users className="w-6 h-6" data-id="element-376" />
  }, {
    title: 'Advisory Board Resume Writing',
    category: 'Board',
    icon: <Briefcase className="w-6 h-6" data-id="element-377" />
  }, {
    title: 'CEO Resume Writing',
    category: 'Executive',
    icon: <Target className="w-6 h-6" data-id="element-378" />
  }, {
    title: 'President Resume Writing',
    category: 'Executive',
    icon: <Award className="w-6 h-6" data-id="element-379" />
  }, {
    title: 'Executive Resume Writing',
    category: 'Executive',
    icon: <Briefcase className="w-6 h-6" data-id="element-380" />
  }, {
    title: 'C-Suite Resume Writing',
    category: 'Executive',
    icon: <Layout className="w-6 h-6" data-id="element-381" />
  }, {
    title: 'Board Biography Development',
    category: 'Branding',
    icon: <FileText className="w-6 h-6" data-id="element-382" />
  }, {
    title: 'Executive Biography Writing',
    category: 'Branding',
    icon: <FileText className="w-6 h-6" data-id="element-383" />
  }, {
    title: 'LinkedIn Executive Branding',
    category: 'Branding',
    icon: <TrendingUp className="w-6 h-6" data-id="element-384" />
  }, {
    title: 'Board Candidate Positioning',
    category: 'Strategy',
    icon: <Target className="w-6 h-6" data-id="element-385" />
  }, {
    title: 'Executive Cover Letters',
    category: 'Branding',
    icon: <FileText className="w-6 h-6" data-id="element-386" />
  }, {
    title: 'Board Governance Profiles',
    category: 'Board',
    icon: <Layout className="w-6 h-6" data-id="element-387" />
  }, {
    title: 'Personal Branding Strategy',
    category: 'Strategy',
    icon: <TrendingUp className="w-6 h-6" data-id="element-388" />
  }, {
    title: 'Career Portfolio Development',
    category: 'Strategy',
    icon: <Briefcase className="w-6 h-6" data-id="element-389" />
  }, {
    title: 'Board Candidate Packages',
    category: 'Board',
    icon: <FileText className="w-6 h-6" data-id="element-390" />
  }, {
    title: 'Executive Career Marketing',
    category: 'Strategy',
    icon: <TrendingUp className="w-6 h-6" data-id="element-391" />
  }];
  // Helper icon since Target isn't imported above
  function Target(props: any) {
    return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-392">
        <circle cx="12" cy="12" r="10" data-id="element-393" />
        <circle cx="12" cy="12" r="6" data-id="element-394" />
        <circle cx="12" cy="12" r="2" data-id="element-395" />
      </svg>;
  }
  const filteredServices = services.filter(service => service.title.toLowerCase().includes(searchTerm.toLowerCase()) || service.category.toLowerCase().includes(searchTerm.toLowerCase()));
  return <section id="services" className="py-24 bg-gray-50" data-id="element-396">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-397">
        <div className="text-center mb-16" data-id="element-398">
          <span className="text-gold font-semibold tracking-widest uppercase text-sm mb-4 block" data-id="element-399">
            Our Expertise
          </span>
          <h2 className="text-3xl md:text-5xl font-serif-display font-bold text-navy-900 mb-6" data-id="element-400">
            Executive & Board Services
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-401">
            Comprehensive branding solutions tailored for senior leaders
            navigating complex career transitions and board appointments.
          </p>
        </div>

        <div className="mb-10 max-w-md mx-auto relative" data-id="element-402">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-403">
            <Search className="h-5 w-5 text-gray-400" data-id="element-404" />
          </div>
          <input type="text" className="block w-full pl-10 pr-3 py-4 border border-gray-200 rounded-sm leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gold focus:border-gold sm:text-sm transition-all shadow-sm" placeholder="Search services or categories..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-405" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-406">
          {filteredServices.map((service, index) => <div key={index} className="bg-white p-8 rounded-sm shadow-sm hover:shadow-md transition-shadow border border-gray-100 group" data-id="element-407">
              <div className="text-navy-300 group-hover:text-gold transition-colors mb-4" data-id="element-408">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-409">
                {service.title}
              </h3>
              <span className="inline-block px-3 py-1 bg-navy-50 text-navy-700 text-xs font-semibold rounded-full uppercase tracking-wider" data-id="element-410">
                {service.category}
              </span>
            </div>)}
        </div>

        {filteredServices.length === 0 && <div className="text-center py-12 text-gray-500" data-id="element-411">
            No services found matching "{searchTerm}". Please try another term.
          </div>}
      </div>
    </section>;
}